import React from 'react';
import classNames from 'classnames';

import { ReviewCardProps } from './ReviewCardProps';
import * as styles from './ReviewCard.module.scss';
import { ImageFromDirectus } from '@components/index';

export const ReviewCard: React.VFC<ReviewCardProps> = ({
	title,
	link,
	quote,
	reviewerName,
	reviewerPosition,
	logo,
	linkVariant,
	alignment = 'default',
}) => {
	const isLinkOutlined = linkVariant === 'outlined';
	const isCentered = alignment === 'center';

	return (
		<div className={classNames(styles.heightLimit)}>
			<div
				className={classNames(
					styles.card,
					isCentered && 'd-flex flex-column align-items-center text-center'
				)}
			>
				<div className={styles.imageContainer}>
					<ImageFromDirectus image={logo} alt={title} />
				</div>
				<p className={classNames(styles.title, 'font-size-sm font-600')}>{title}</p>
				<p className={classNames(styles.quote, 'font-size-sm font-300')}>
					{quote}
				</p>
				<p className="mt-3 font-600 uppercase">{reviewerName}</p>
				<p className="mt-1 font-300">{reviewerPosition}</p>
				<div className="mt-3 d-flex justify-content-center align-items-center">
					<a
						href={link}
						target="_blank"
						rel="noreferrer"
						className={classNames(
							'uppercase',
							isLinkOutlined &&
								`${styles.linkOutlined} bttn bttn-orange-border link`
						)}
					>
						Vollständige Bewertung lesen
					</a>
				</div>
			</div>
		</div>
	);
};
